<template>
  <section class="stock_list_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row mb-3">
      <div class="col-8">
        <!-- <stock-state
          head="Total Quantity"
          :state="qtySum"
          type="string"
        ></stock-state>
        <stock-state
          head="Quantity/Month"
          :state="qtyPerMonthSum"
          type="string"
        ></stock-state>
        <stock-state
          head="Retail Price"
          :state="retailPriceSum"
          type="money"
        ></stock-state> -->
      </div>
      <div class="col-4">
        <!-- <b-btn
          variant="info"
          size="md"
          class="float-right ml-2"
          to="#"
          @click="updateStockLevel"
          >Update Stock Level</b-btn
        > -->
        <b-btn
          variant="primary"
          size="md"
          class="float-right"
          :to="'/stock/add'"
          >Add / Reduce Stock</b-btn
        >
        <!-- <b-btn
          variant="warning"
          size="md"
          class="float-right mr-2"
          to="#"
          @click="showReturnsModal"
          >Returns</b-btn
        > -->
      </div>
    </div>

    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col md="3" class="my-1">
        <b-form-group horizontal label="Per page" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
      <b-col md="3" class="my-1">
        <b-form-group horizontal label="Type" class="mb-0">
          <select v-model="stockable" class="custom-select" @change="getStock">
            <option
              :key="index"
              v-for="(type, index) in types"
              v-bind:value="type.value"
              >{{ type.name }}</option
            >
          </select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-table
      show-empty
      v-if="items"
      stacked="md"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <template slot="cell(retailPrice)" slot-scope="row">
        {{ (Math.round(row.item.retailPrice * 100) / 100).toFixed(2) }}
      </template>
      <template slot="cell(days_left)" slot-scope="row">
        <div :class="daysLeftClass(row.item.days_left)">
          {{ row.item.days_left }}
        </div>
      </template>
      <template slot="cell(revenue_month)" slot-scope="row">
        {{ row.item.revenue_month }}
      </template>
      <!-- <template slot="cell(dims)" slot-scope="row">
        {{ row.item.length }} x {{ row.item.width }} x
        {{ row.item.height }}
      </template> -->

      <template slot="cell(low_stock)" slot-scope="row">
        <img :src="'/assets/icons/close.png'" v-if="row.item.low_stock" />
        <img :src="'/assets/icons/tick.png'" v-else />
      </template>

      <template slot="cell(actions)" slot-scope="row">
        <b-btn
          class="ml-2"
          size="sm"
          variant="warning"
          :to="'/stock/' + row.item.stock_product_id + '/edit'"
          >Edit</b-btn
        >
        <b-btn
          class="ml-2"
          size="sm"
          variant="info"
          :to="'/stock/' + row.item.stock_product_id + '/log'"
          >Log</b-btn
        >
        <!-- <b-btn
          class="ml-2"
          size="sm"
          variant="light"
          @click="labels(row.item.stock_product_id)"
          >Labels</b-btn
        >
        <b-btn
          class="ml-2"
          size="sm"
          variant="success"
          @click="boxlabel(row.item.stock_product_id)"
          >Box Labels</b-btn
        > -->
        <!-- <b-btn
          class="ml-2"
          size="sm"
          variant="secondary"
          @click="showRecipe(row.item.stock_product_id)"
          >Recipe</b-btn
        > -->
        <b-btn
          class="ml-2"
          size="sm"
          variant="danger"
          @click="deleteConfirm(row.item.stock_product_id, row.item.model)"
          >Delete</b-btn
        >
        <!-- <b-btn
          class="ml-2"
          size="sm"
          variant="warning"
          style="background-color: purple;color: #fff;border-color:purple;"
          @click="showOutstandingOrders(row.item.model)"
          >Orders</b-btn
        > -->
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>
    <recipe-modal :item="selectedStockItem" ref="recipeModal"></recipe-modal>
    <returns-modal ref="returnsModal"></returns-modal>
    <outstanding-orders-modal
      ref="outstandingOrdersModal"
      :model="selectedModel"
    ></outstanding-orders-modal>
  </section>
</template>

<script>
import StockState from "@/components/stock/StockState.vue";
import RecipeModal from "@/components/stock/RecipeModal.vue";
import ReturnsModal from "@/components/stock/ReturnsModal.vue";
import OutstandingOrdersModal from "@/components/stock/OutstandingOrdersModal.vue";
export default {
  name: "shopify-stock",
  components: {
    StockState,
    "recipe-modal": RecipeModal,
    "returns-modal": ReturnsModal,
    "outstanding-orders-modal": OutstandingOrdersModal
  },
  mounted: function() {
    //get stock
    this.getStock();
    console.log("shopify stock");
  },
  data() {
    return {
      selectedStockItem: null,
      qtySum: "",
      qtyPerMonthSum: "",
      retailPriceSum: "",
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Stock", active: true }
      ],
      fields: [
        {
          key: "stock_product_id",
          label: "#",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "model",
          label: "Model",
          sortable: true,
          sortDirection: "desc",
          class: "model-cell"
        },
        { key: "name", label: "Name", sortable: true, sortDirection: "desc" },
        {
          key: "quantity",
          label: "Quantity",
          class: "text-center",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "low_stock",
          label: "Stock",
          class: "text-center",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "days_left",
          label: "Days Left",
          class: "text-center align-middle",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "per_month",
          label: "Qty/Month",
          class: "text-center",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "retailPrice",
          label: "Retail Price",
          class: "text-center",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "revenue_month",
          label: "Revenue/Month",
          class: "text-center",
          sortable: true,
          sortDirection: "desc"
        },
        // {
        //   key: "dims",
        //   label: "Dimensions",
        //   class: "text-center",
        //   sortable: true
        // },
        { key: "actions", label: "Actions", class: "text-center actions-col" }
      ],
      items: null,
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      pageOptions: [25, 50, 100, 200],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      stockable: "yes",
      types: [
        { value: "yes", name: "Stockable" },
        { value: "no", name: "Non-Stockable" },
        { value: "", name: "All" }
      ],
      selectedModel: null
    };
  },
  methods: {
    updateStockLevel() {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/stock/update-level").then(
        response => {
          this.$swal({
            title: "Success!",
            showConfirmButton: false,
            timer: 1000,
            html: "Stock Levels Updated!",
            type: "success",
            onClose: () => {
              loader.hide();
              this.$router.push({ name: "stock" });
            }
          });
        },
        error => {
          console.log(error);
        }
      );
    },
    showOutstandingOrders(model) {
      this.selectedModel = model;
      this.$refs.outstandingOrdersModal.showModal();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getStock() {
      let loader = this.$loading.show();
      this.$http
        .get(this.APIURL + this.BRAND + "/stock?stockable=" + this.stockable)
        .then(
          response => {
            this.qtySum = response.data.totals.qtySum;
            this.qtyPerMonthSum = response.data.totals.qtyPerMonthSum;
            this.retailPriceSum = response.data.totals.retailPriceSum;
            this.items = response.data.products;
            this.totalRows = this.items.length;
            loader.hide();
          },
          error => {
            console.log(error);
          }
        );
    },
    labels(stock_product_id) {
      let url = this.APIURL + this.BRAND + "/stock/labels/" + stock_product_id;
      window.open(url, "_blank");
    },
    boxlabel(stock_product_id) {
      let url =
        this.APIURL + this.BRAND + "/stock/boxlabel/" + stock_product_id;
      window.open(url, "_blank");
    },
    deleteConfirm(stock_product_id, model) {
      this.$swal({
        title: "Are you sure?",
        text: "You want to delete model: " + model,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.deleteStock(stock_product_id);
        }
      });
    },
    deleteStock(stock_product_id) {
      let loader = this.$loading.show();
      this.$http
        .delete(this.APIURL + this.BRAND + "/stock/" + stock_product_id)
        .then(
          () => {
            this.getStock();
            loader.hide();
          },
          error => {
            console.log(error);
          }
        );
    },
    daysLeftClass(daysLeft) {
      if (daysLeft > 0 && daysLeft <= 45) {
        return "bg-danger text-light";
      } else if (daysLeft > 45 && daysLeft <= 90) {
        return "bg-warning text-light";
      } else if (daysLeft > 90) {
        return "bg-success text-light";
      }
    },
    showRecipe(id) {
      this.selectedStockItem = id;
      this.$refs.recipeModal.showModal();
    },
    showReturnsModal() {
      this.$refs.returnsModal.showModal();
    }
  }
};
</script>
